<template>
    <form
        method="post"
        action="/cart/add"
        enctype="multipart/form-data"
        data-product-form
        @submit.prevent="handleFormSubmit"
    >
        <input type="hidden" name="form_type" value="product" />
        <input type="hidden" name="utf8" value="✓" />
        <input
            type="hidden"
            name="id"
            :value="selectedDiamond.shopifyVariantId"
        />
        <button
            name="add"
            class="diamonds__buy-btn"
            type="submit"
            data-product-atc=""
        >
            {{ $t("components.buyButtonLabel") }}
        </button>
    </form>
</template>

<script lang="ts">
import { computed, defineComponent } from "vue";
import useStore from "@/composables/useStore";

export default defineComponent({
    name: "BuyButton",
    setup() {
        const store = useStore();
        const selectedDiamond = computed(
            () => store.state.userSelection.diamond
        );

        function handleFormSubmit(e: Event) {
            const cart = document.querySelector("shopify-cart");

            if (cart) {
                e.preventDefault();
                //@ts-expect-error unknown custom element
                cart.addItemFromForm(e.target);
            }
        }

        return {
            selectedDiamond,
            handleFormSubmit
        };
    }
});
</script>

<style>
.diamonds__buy-btn {
    margin: 0;
    padding: 1rem 2rem;
    border: none;
    color: white;
    background-color: #111111;
    border-radius: 0;
    cursor: pointer;
    width: 100%;
    text-transform: uppercase;
    font-size: 0.875rem;
    line-height: 0.875rem;
    letter-spacing: 0.12em;
    font-weight: 400;
    white-space: nowrap;
}

.diamonds__buy-btn:hover {
    background-color: rgb(138, 137, 137);
}
</style>
